module.exports = __webpack_public_path__ + "static/media/icon_menu.1a5d7a81.svg";